__turbopack_context__.v({
  "cookieButton": "FreeTextContent-module-scss-module__E6FILW__cookieButton",
  "embeddedImage": "FreeTextContent-module-scss-module__E6FILW__embeddedImage",
  "embeddedImageDesktop": "FreeTextContent-module-scss-module__E6FILW__embeddedImageDesktop",
  "embeddedImageMobile": "FreeTextContent-module-scss-module__E6FILW__embeddedImageMobile",
  "h1": "FreeTextContent-module-scss-module__E6FILW__h1",
  "h2": "FreeTextContent-module-scss-module__E6FILW__h2",
  "h3": "FreeTextContent-module-scss-module__E6FILW__h3",
  "h4": "FreeTextContent-module-scss-module__E6FILW__h4",
  "h5": "FreeTextContent-module-scss-module__E6FILW__h5",
  "h6": "FreeTextContent-module-scss-module__E6FILW__h6",
  "heading": "FreeTextContent-module-scss-module__E6FILW__heading",
  "hr": "FreeTextContent-module-scss-module__E6FILW__hr",
  "link": "FreeTextContent-module-scss-module__E6FILW__link",
  "list": "FreeTextContent-module-scss-module__E6FILW__list",
  "orderedList": "FreeTextContent-module-scss-module__E6FILW__orderedList",
  "paragraph": "FreeTextContent-module-scss-module__E6FILW__paragraph",
  "quote": "FreeTextContent-module-scss-module__E6FILW__quote",
  "table": "FreeTextContent-module-scss-module__E6FILW__table",
  "wrapper": "FreeTextContent-module-scss-module__E6FILW__wrapper",
});
